var React = require('react');

function Locked (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M40.4 60h-35c-3 0-5.4-2.4-5.4-5.3V28.1c0-2.9 2.4-5.3 5.4-5.3h35c3 0 5.4 2.4 5.4 5.3v26.6c-.1 2.9-2.5 5.3-5.4 5.3zm-35-34.2c-1.3 0-2.4 1-2.4 2.3v26.6C3 56 4 57 5.4 57h35c1.3 0 2.4-1 2.4-2.3V28.1c0-1.3-1.1-2.3-2.4-2.3h-35z","key":0}),React.createElement("path",{"d":"M9.3 25.8a1.54 1.54 0 0 1-1.5-1.5v-9.5c0-3.9 1.5-7.6 4.3-10.4S18.8 0 22.8 0h.1c4 0 7.9 1.6 10.7 4.4s4.3 6.5 4.3 10.3v9.5a1.54 1.54 0 0 1-1.5 1.5c-.8 0-1.4-.6-1.4-1.4v-9.5c0-3.1-1.2-6-3.5-8.2C29.2 4.2 26.2 3 22.9 3c-3.3-.1-6.4 1.3-8.7 3.6-2.2 2.2-3.4 5.2-3.4 8.3v9.5c-.1.7-.7 1.4-1.5 1.4zm13.6 20.9a1.54 1.54 0 0 1-1.5-1.5v-7.6a1.54 1.54 0 0 1 1.5-1.5 1.54 1.54 0 0 1 1.5 1.5v7.6a1.54 1.54 0 0 1-1.5 1.5z","key":1})]);
}

Locked.defaultProps = {"baseProfile":"tiny","viewBox":"0 0 45.7 60","overflow":"visible"};

module.exports = Locked;

Locked.default = Locked;
